import service from "../../Service/service";

const CreateOrUpdateAsset = async (payload) => {
    var data = {};
    try {
        await service.CreateOrUpdate("Asset/CreateOrUpdate", payload).then((res) => {
            if (res != undefined) {

                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        var data = "something went wrong"
    }
    return data;
}

const GetAllAssets = async () => {
    var data = {};
    try {
        await service.GetAll("Asset/GetAll").then((res) => {
            if (res != undefined) {
                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        var data = "something went wrong"
    }
    return data;
}

const GetAssetsById = async (id) => {
    var data = {};
    try {
        await service.GetById("Asset/GetById?id=", id).then((res) => {
            if (res != undefined) {
                data = res.data;
            }
            else {
                data = "data not coming";
            }
        })
    } catch (error) {
        console.log(error);
        var data = "something went wrong"
    }
    return data;
}
export { CreateOrUpdateAsset, GetAllAssets, GetAssetsById }